import { emailSubscriber } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getEmailSubscribersList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(emailSubscriber.emailSubscriberBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getEmailSubscriberObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${emailSubscriber.emailSubscriberBase}${id}/`)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  addEmailSubscribers(data) {
    return new Promise((resolve, reject) => {
      axios
        .post(emailSubscriber.emailSubscriberBase, data)
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  getEmailSubscribersOptions(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .options(emailSubscriber.emailSubscriberBase, {
          params: params,
        })
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  updateGetEmailSubscribers(payload) {
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${emailSubscriber.emailSubscriberBase}${payload.id}/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
  partiallyUpdateEmailSubscribers(payload) {
    return new Promise((resolve, reject) => {
      axios
        .patch(
          `${emailSubscriber.emailSubscriberBase}${payload.id}/`,
          payload.data
        )
        .then((res) => {
          resolve(handleResponse(res));
        })
        .catch((err) => {
          reject(handleError(err));
        });
    });
  },
});
